import { createSlice } from "@reduxjs/toolkit";
import { viewOptionSliceName } from "../constants";
export const buttonOption = (view, text, minWidth, action) => ({
    textSelector: () => text,
    minWidth,
    action,
    type: "button",
});
export const toggleOption = (view, key, text, minWidth, selectedText) => ({
    textSelector: (state) => selectedText && state.viewOptions[view]?.[key] ? selectedText : text,
    valueSelector: (state) => state.viewOptions[view]?.[key],
    minWidth,
    type: "toggle",
});
export const counterOption = (view, key, text, minValue, maxValue, minWidth, type = "counter", amountPerTick = 1) => ({
    textSelector: (state) => `${text} ${state.viewOptions[view]?.[key]}`,
    valueSelector: (state) => state.viewOptions[view]?.[key],
    type,
    maxValue,
    minValue,
    minWidth,
    amountPerTick,
});
export const backgroundOption = (view) => toggleOption(view, "background", "T", 1, "O");
export const borderOption = (view) => toggleOption(view, "border", "BORDER", 8);
export const linesOption = (view, minValue = 2, maxValue = 20, minWidth = 8) => counterOption(view, "lines", "LINES", minValue, maxValue, minWidth);
export const fontOption = (view, minValue = 1, maxValue = 3, minWidth = 6) => counterOption(view, "font", "FONT", minValue, maxValue, minWidth);
export const brightOption = (view) => counterOption(view, "bright", "BRIGHT", 0, 100, 10, "delta");
export function viewOptionFactory(initialState) {
    const viewOptionSlice = createSlice({
        name: viewOptionSliceName,
        initialState,
        reducers: {
            setViewOption(state, action) {
                const { view, key, value } = action.payload;
                state[view][key] = value;
            },
            setViewOptionState(state, action) {
                return { ...initialState, ...action.payload };
            },
        },
    });
    const { setViewOption: _setViewOption, setViewOptionState } = viewOptionSlice.actions;
    function setViewOption(view, key, value) {
        return _setViewOption({ view, key, value });
    }
    const deltaViewOption = (view, key, delta, minValue, maxValue, onError) => {
        return (dispatch, getState) => {
            const state = getState().viewOptions;
            const newVal = state[view][key] + delta;
            if (newVal >= minValue && newVal <= maxValue) {
                dispatch(setViewOption(view, key, newVal));
            }
            else {
                onError?.(newVal < minValue ? "MIN_VALUE" : "MAX_VALUE");
            }
        };
    };
    const viewOptionSelector = (state, view) => state[viewOptionSliceName][view];
    return {
        viewOptionSlice,
        buttonOption,
        toggleOption,
        counterOption,
        backgroundOption,
        borderOption,
        linesOption,
        fontOption,
        brightOption,
        setViewOption,
        setViewOptionState,
        deltaViewOption,
        viewOptionSelector,
    };
}
//# sourceMappingURL=viewOptionFactory.js.map